let timelineAbort = null;

export const initTimeline = () => {
  if (timelineAbort) {
    timelineAbort.abort();
  }

  const steps = document.querySelectorAll(".timeline-teaser__bar-setup");
  const blocks = document.querySelectorAll(".timeline-teaser__content");

  if (!steps.length) {
    return;
  }

  timelineAbort = new AbortController();
  const { signal } = timelineAbort;

  steps.forEach((step) => {
    step.addEventListener(
      "click",
      () => {
        const targetStep = step.getAttribute("data-step");

        steps.forEach((s) => {
          s.classList.toggle(
            "active",
            parseInt(s.getAttribute("data-step"), 10) <= parseInt(targetStep, 10)
          );
        });

        blocks.forEach((block) => {
          block.classList.toggle("active", block.getAttribute("data-step") === targetStep);
        });
      },
      { signal }
    );
  });
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initTimeline, { once: true });
} else {
  initTimeline();
}
